import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const BookCard = ({ book, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/books/${book.slug || book.id}`}
        className="group block"
        data-testid={`book-card-${book.id}`}
      >
        <div className="card-surface overflow-hidden mb-4">
          <div className="relative aspect-[2/3] overflow-hidden">
            <img
              src={book.cover_image}
              alt={book.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
        </div>
        <div className="space-y-2">
          <p className="mono text-xs text-white/40">{book.genre}</p>
          <h3
            className="text-lg font-medium text-white group-hover:text-gold transition-colors duration-300"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {book.title}
          </h3>
          <p className="text-sm text-white/50">{book.author}</p>
          <p className="mono text-sm text-gold">
            {book.formats && book.formats.length > 1 ? 'from ' : ''}${book.price?.toFixed(2)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};

export default BookCard;
